/**
 * Browser file helpers of the Assets panel (W2-10 projects-data): pick files, read them, offer a download.
 */

/** Opens the browser's file picker; resolves with the chosen files (empty when cancelled). */
export function pickFiles(accept: string, multiple: boolean): Promise<File[]> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.multiple = multiple;
    input.style.display = 'none';
    const done = (files: File[]): void => {
      input.remove();
      resolve(files);
    };
    input.addEventListener(
      'change',
      () => {
        done(input.files === null ? [] : [...input.files]);
      },
      { once: true },
    );
    input.addEventListener(
      'cancel',
      () => {
        done([]);
      },
      { once: true },
    );
    document.body.append(input);
    input.click();
  });
}

/** Reads a File (or Blob) as bytes. */
export async function readBytes(file: Blob): Promise<Uint8Array> {
  const buf =
    typeof file.arrayBuffer === 'function' ? await file.arrayBuffer() : await new Response(file).arrayBuffer();
  return new Uint8Array(buf);
}

/** Saves `blob` under `fileName` through a temporary object URL (no-op where object URLs do not exist). */
export function downloadBlob(blob: Blob, fileName: string): void {
  if (typeof URL.createObjectURL !== 'function') return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.append(a);
  a.click();
  a.remove();
  // Give the browser time to start the download before the URL is released.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 30_000);
}
